var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoArrowDrowdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mp_m_mypage_09_01",
    clipPath: "url(#clip0_8_256)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    transform: "translate(-321 -291)",
    fill: "#F8F7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1038"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -60.5,
    y: -13.5,
    width: 84,
    height: 39,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_arrow_right_2",
    d: "M11.7096 2.86572L6.35248 7.86572L1.00463 2.85706",
    stroke: "black",
    strokeWidth: 2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "white",
    transform: "translate(-321 -291)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDrowdown);
export default __webpack_public_path__ + "static/media/ico_arrow_drowdown.56c07177b948798d84f2fbccd39da4cd.svg";
export { ForwardRef as ReactComponent };